import React from 'react'
import { Link } from 'react-router-dom';

export default class ListButtonComponent extends React.Component {
	render() {
		return (
			<>
                <Link
                    className={`btn btn-sm ${this.props.active === 'using' ? 'btn-primary' : 'btn-outline-primary'} m-1`}
                    disabled={ this.props.active === 'using' }
                    to={ '/dich-vu-vps/dang-su-dung.html' }
                >
                    Đang sử dụng
                </Link>
                <Link
                    className={`btn btn-sm ${this.props.active === 'on' ? 'btn-primary' : 'btn-outline-primary'} m-1`}
                    disabled={ this.props.active === 'on' }
                    to={ '/dich-vu-vps/con-han.html' }
                >
                    Còn hạn
                </Link>
                <Link
                    className={`btn btn-sm ${this.props.active === 'expired' ? 'btn-primary' : 'btn-outline-primary'} m-1`}
                    disabled={ this.props.active === 'expired' }
                    to={ '/dich-vu-vps/da-het-han.html' }
                >
                    Đã hết hạn
                </Link>
                <Link
                    className={`btn btn-sm ${this.props.active === 'cancel' ? 'btn-primary' : 'btn-outline-primary'} m-1`}
                    disabled={ this.props.active === 'cancel' }
                    to={ '/dich-vu-vps/huy-xoa-chuyen.html' }
                >
                    Hủy - xóa - Chuyển
                </Link>
                <Link
                     className={`btn btn-sm ${this.props.active === 'all' ? 'btn-primary' : 'btn-outline-primary'} m-1`}
                    disabled={ this.props.active === 'all' }
                    to={ '/dich-vu-vps/tat-ca-dich-vu-vps.html' }
                >
                    Tất cả dịch vụ
                </Link>
            </>
		)
	}
}